export default "__VITE_ASSET__Cf6b5_zR__"